import Vue from 'vue'
import Vuex from 'vuex'
import { createLogger } from 'vuex'
import api from '@/api'

Vue.use(Vuex)

const development = process.env.NODE_ENV !== 'production'

// initial state
const state = {
  auth: {
    token: '',
    username: '',
  },
  message: {
    show: false,
    text: '',
    type: '',
  },
}

// mutations
const mutations = {
  setAuth (state, { token, username }) {
    state.auth.token = token
    state.auth.username = username
  },
  setMessage (state, { text, type }) {
    state.message.show = true
    state.message.text = text
    state.message.type = type
  },
  setMessageShow (state, value) {
    state.message.show = value
  }
}

// actions
const actions = {
  async signin ({ commit }, { username, password }) {
    try {
      let response = await api.signin(username, password)

      if (response.data) {
        Vue.$log.debug(response.data)

        if (response.data.success) {
          commit('setAuth', {
            token: response.data.token,
            username: username,
          })

          commit('setMessage', {
            text: 'Successfully signed in',
            type: 'success',
          })
        } else {
          commit('setMessage', {
            text: 'Wrong username or password',
            type: 'error',
          })
        }

        return response.data.success
      } else {
        Vue.$log.debug(response)
  
        commit('setMessage', {
          text: 'Server bad response',
          type: 'error',
        })
  
        return false
      }
    } catch (error) {
      Vue.$log.debug(error)

      commit('setMessage', {
        text: 'Server error',
        type: 'error',
      })

      return false
    }
  },
  async signout ({ commit }) {
    try {
      let response = await api.signout()
      
      commit('setAuth', {
        token: '',
        username: '',
      })

      commit('setMessage', {
        text: 'Successfully signed out',
        type: 'success',
      })

      if (response.data) {
        Vue.$log.debug(response.data)
      } else {
        Vue.$log.debug(response)
      }
    } catch (error) {
      Vue.$log.debug(error)
    }
  },
  updateMessage ({ commit }, { text, type }) {
    commit('setMessage', {
      text: text,
      type: type
    })
  },
  updateMessageShow ({ commit }, value) {
    commit('setMessageShow', value)
  },
}

// getters
const getters = {
  getToken (state) {
    return state.auth.token
  },
  showMessage (state) {
    return state.message.show;
  },
  signedIn (state) {
    return state.auth.token !== ''
  },
  firstLetterUsername (state) {
    if (state.auth.username !== '') {
      return state.auth.username.charAt(0).toUpperCase()
    } else {
      return ''
    }
  }
}

const store = new Vuex.Store({
  strict: development,
  plugins: development ? [createLogger()] : [],
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
})

export default store
